module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/remit-to/remit-to.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/remit-to/remit-to.component.scss
// module chunks = main